var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashBoarNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.669 0H5.33C1.929 0 0 1.929 0 5.33V14.67C0 18.07 1.929 20 5.33 20H14.669C18.07 20 20 18.07 20 14.67V5.33C19.99 1.929 18.07 0 14.669 0Z",
    fill: "#E57422"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.63965V14.6396H15.6667",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.9733L7.98844 9.18397C8.3109 8.89097 8.73097 8.72862 9.16667 8.72862C9.60236 8.72862 10.0224 8.89097 10.3449 9.18397L10.9902 9.78664C11.175 9.95586 11.3942 10.0832 11.6328 10.1599C11.8713 10.2366 12.1236 10.2609 12.3724 10.2311C12.6189 10.2054 12.8567 10.1254 13.0686 9.9969C13.2805 9.86842 13.4614 9.69462 13.5982 9.48797L14.9956 7.30664",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoarNewsIcon);
export default __webpack_public_path__ + "static/media/DashBoarNewsIcon.f41154a60a57f975ed2e944f994f6be3.svg";
export { ForwardRef as ReactComponent };